import { tickerItems } from '@/mocks/home';

export default function Ticker() {
  const loop = [...tickerItems, ...tickerItems];

  return (
    <div className="bg-primary-700 text-background-50">
      <div className="mx-auto max-w-[1360px] px-4 md:px-6 lg:px-10">
        <div className="flex items-center gap-4 h-12">
          <span className="shrink-0 flex items-center gap-2 text-xs md:text-sm font-medium">
            <span className="w-1.5 h-1.5 rounded-full bg-accent-400 bl-pulse-dot" />
            最新爆料
          </span>
          <span className="hidden sm:block w-px h-5 bg-background-50/25" />
          <div className="relative flex-1 overflow-hidden">
            <div className="flex whitespace-nowrap bl-marquee">
              {loop.map((text, i) => (
                <a
                  key={`${text}-${i}`}
                  href="#brief"
                  className="inline-flex items-center gap-2 pr-10 text-xs md:text-sm text-background-100 hover:text-accent-400 transition-colors"
                >
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-s-line text-base" />
                  </span>
                  {text}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}